import { CategoryItem } from "../categories/categories.types";

export enum CART_ACTION_TYPES {
  SET_CART_ITEMS = "cart/SET_CART_ITEMS",
  SET_IS_CART_OPEN = "cart/SET_IS_CART_OPEN",
  SET_CLEAR_CART = "cart/SET_CLEAR_CART",
}

export type CartItem = CategoryItem & {
  quantity: number;
};
